import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const StyledContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  box-sizing: border-box;
  position: relative;
  max-width: ${props =>
    props.size === "small"
      ? "768px"
      : props.size === "medium"
      ? "1020px"
      : props.size === "large"
      ? "1110px"
      : "1200px"};
`

const Container = ({ size, children }) => {
  return (
    <StyledContainer size={size} className={`container container--${size}`}>
      {children}
    </StyledContainer>
  )
}

Container.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large", "xlarge"]),
}

Container.defaultProps = {
  size: "medium",
}

export { Container }
